import React, { Component } from "react";

export default class Heading extends Component {
	render() {	
		if(this.props.subheading) return <h2>{this.props.children}</h2>;
		return <h1>{this.props.children}</h1>;
	}
}



// WEBPACK FOOTER //
// ./src/components/Heading/Heading.js